<template>
<div class="container-fluid">
    <div class="alert alert-info alert-dismissible">
        <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
        <h5><i class="icon fas fa-exclamation-triangle"></i> Information!</h5>
        <div><label class="text-info fly-in" style='font-weight: bold;font-family: "Times New Roman", Times, serif'><i><b>Class XI admissions window for applying outside cluster school(s) is opened from Date ({{this.from_date}}) to ({{this.to_date}})</b></i></label><br></div>
    </div>
    <div class="callout callout-danger" style="display:none" id="screenPermission">
        <h5 class="bg-gradient-danger">Sorry!</h5>
        <div id="validation_message"></div>
    </div>
    <div class="card card-primary card-outline" id="main_form">
        <div class="card-body">
            <div class="form-group" >
                <div class="p-2 mb-1 bg-secondary text-white">
                    <label > <b >Basic Details</b></label>
                </div>
                <div class="row form-group">
                    <template v-if="!is_student">
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >CID No/Reference  : </label>
                            <label class="text-primary">{{std_admission_details.CidNo}}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >Name of Student :</label>
                            <label class="text-primary">{{ std_admission_details.FirstName}} {{ std_admission_details.MiddleName=='null' ? '': std_admission_details.MiddleName}} {{ std_admission_details.LastName=='null' ? '': std_admission_details.LastName}}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >Gender :</label>
                            <label class="text-primary">{{ genderArray[std_admission_details.CmnSexId]}}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label >Date of Birth :</label>
                        <label class="text-primary">{{std_admission_details.DateOfBirth}}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >Date of Apply :</label>
                            <label class="text-primary">{{ std_admission_details.DateOfApply}}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >Class :</label>
                        <label class="text-primary">{{ std_admission_details.class_id}} </label>
                        </div>
                    </template>
                    <template v-else>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" >CID No/Reference  : </label>
                                <label class="text-primary">{{std_admission_details.CidNo}}</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" >Name of Student :</label>
                                <label class="text-primary">{{ std_admission_details.Name}} </label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" >Gender :</label>
                                <label class="text-primary">{{ genderArray[std_admission_details.CmnSexId]}}</label>
                            </div>
                            <br>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" >Student Code :</label>
                                <label class="text-primary">{{ this.student_code}}</label>
                            </div>
                            <br>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" >Date of Birth :</label>
                                <label class="text-primary">{{ this.dob}}</label>
                            </div>
                            
                    </template>
                </div>
                <hr>
                <div class="p-2 mb-1 bg-secondary text-white">
                    <label > <b >Previous School Details</b></label>
                </div>
                <div class="row form-group" id="present_school">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label class="required" >Dzongkhag/Thromde : </label>
                        <label class="text-primary">{{this.student_form.dzongkhagName}}</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label >School : </label>
                        <label class="text-primary">{{ this.std_present_school }} {{this.level}}</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label>Class : </label>
                        <label class="text-primary"><span id="present_class"></span>{{this.std_present_class}} <span v-if="this.stream">{{this.stream}}</span></label>
                    </div>
                </div>
                <!-- updating parents details -->
                <div class="modal fade" id="screening-modal" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">{{ this.student_form.relation }} Details</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row form-group" >
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <label >Working Address: </label>
                                        <input type="text" class="form-control" rows="3" @change="remove_error('workingAddress')" :class="{ 'is-invalid': student_form.errors.has('workingAddress') }" id="workingAddress" v-model="student_form.workingAddress" placeholder="Working address"/>
                                        <has-error :form="student_form" field="workingAddress"></has-error>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <label >Contact Number: </label>
                                        <input type="number" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "8" minlength = "8" class="form-control" @change="remove_error('contactNumber')" :class="{ 'is-invalid': student_form.errors.has('contactNumber') }" id="contactNumber" v-model="student_form.contactNumber" placeholder="Contact No">
                                        <has-error :form="student_form" field="contactNumber"></has-error>
                                    </div>
                                </div> 
                                <div class="form_group row">
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <label >Residence Address: </label>
                                        <input type="text" class="form-control" rows="3" @change="remove_error('residence')" :class="{ 'is-invalid': student_form.errors.has('residence') }" id="residence" v-model="student_form.residence" placeholder="Residence Address"/>
                                        <has-error :form="student_form" field="residence"></has-error>
                                    </div>
                                </div><br>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-flat btn-sm btn-primary"  @click="UpdateParents()"> Update</button>
                                <button data-bb-handler="cancel" type="button" data-dismiss="modal" class="btn btn-flat btn-sm btn-danger">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="p-2 mb-1 bg-info text-white">
                    <label > <b >Parents/Guardian Details</b></label>
                </div>
                <div class="form-group table-responsive" >
                    <table id="list-student-left" class="table table-bordered table-striped table-head-fixed">
                        <thead>
                            <tr>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>No.</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Name</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Relation</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>CID</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Working Address</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Residence Address</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Contact Number</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, count) in parents_details" :key="count">
                                <td>{{ count + 1 }} </td>
                                <td>{{ item.Name }}</td>
                                <td>{{ item.Relationship }}</td>
                                <td>{{ item.CidNo }}</td>
                                <td>{{ item.WorkAddress }}</td>
                                <td>{{ item.ResidenceAddress }}</td>
                                <td>{{ item.ContactNo }}</td>
                                <td>
                                    <a href="#" class="btn btn-info btn-sm btn-flat text-white" @click="showedit(item)"><i class="fas fa-edit"></i > Edit</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body pb-0 mb-0">
        <div class="form-group row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="mb-0" id="err_message"></label><br>
            </div>
        </div>
    </div>
    
    <!-- dzongkhag/school preference -->
    <div class="card card-primary card-outline" id="main1">
        <div class="form-group">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label>Dzongkhag/Thromde:<i class="text-danger">*</i></label>
                    <select  v-model="student_form.dzongkhag" name="dzongkhag" @change="getschoolList('dzongkhag'),removeerror('dzongkhag')"  :class="{ 'is-invalid select2 select2-hidden-accessible': student_form.errors.has('dzongkhag') }" class="form-control select2" id="dzongkhag">
                            <option v-for="(item, index) in dzongkhagList" :key="index" v-bind:value="item.id">{{item.name}}</option>
                    </select>
                    <has-error :form="student_form" field="dzongkhag"></has-error>
                    <span class="text-danger" id="dzongkhag_err"></span>
                </div>
            </div>
        <div class="card-body">
            <div class="form-group">
            <label><b>School Preference </b></label>
            <small><i>(*Note: <i class="text-danger">*</i> (Symbol) meaning school selection from dropdown is compulsory) and "Optional" meaning school selection is Optional)</i></small>
                <div class="row form-group">
                    <div class="card-body col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group table-responsive">
                            <table id="dynamic-table" class="table table-sm table-bordered table-striped ">
                                <thead class="p-3 mb-2 bg-secondary text-white border border-info">
                                    <tr >
                                        <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;'>School Preference</th>
                                        <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif; '>Select School</th>
                                        <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;'>Class</th>
                                    </tr>
                                </thead>
                                <tbody class="border border-info">
                                        <tr>
                                            <td style = "width:15%"><span class="badge badge-white">Preference 1 <i class="text-danger">*</i></span></td>
                                            <td style = "width:70%">
                                                <select v-model="student_form.schoolPreference1" :class="{ 'is-invalid select2 select2-hidden-accessible': student_form.errors.has('schoolPreference1') }" class="form-control select2" name="schoolPreference1" id="schoolPreference1">
                                                    <option v-for="(item, index) in schoolList" :key="index" v-bind:value="item.id">{{item.name}} {{item.Level}}</option>
                                                </select>
                                                <has-error :form="student_form" field="schoolPreference1"></has-error>
                                                <span class="text-danger" id="schoolPreference1_err"></span>
                                            </td>
                                            <td v-if="this.std_class" id="class" style = "width:15%">
                                                <span>{{this.std_class}} <span v-if="this.stream">{{this.stream}}</span></span>
                                            </td>
                                            <td v-else>
                                            </td>
                                        </tr>
                                        <br>
                                        <tr>
                                            <td style = "width:15%"><span class="badge badge-white">Preference 2 (Optional)</span></td>
                                            <td style = "width:40%">
                                                <select v-model="student_form.schoolPreference2" :class="{ 'is-invalid select2 select2-hidden-accessible': student_form.errors.has('schoolPreference2') }" class="form-control select2" name="schoolPreference2" id="schoolPreference2">
                                                    <option value=""> -- Select-- </option>
                                                    <option v-for="(item, index) in schoolList" :key="index" v-bind:value="item.id">{{item.name}} {{item.Level}}</option>
                                                </select>
                                                <has-error :form="student_form" field="schoolPreference2"></has-error>
                                                <span class="text-danger" id="schoolPreference2_err"></span>
                                            </td>
                                            <td v-if="this.std_class" id="class" style = "width:15%">
                                                <span>{{this.std_class}} <span v-if="this.stream">{{this.stream}}</span></span>
                                            </td>
                                                <td v-else>
                                            </td>
                                        </tr>
                                        <br>
                                        <tr>
                                            <td style = "width:15%"><span class="badge badge-white">Preference 3 (Optional)</span></td>
                                            <td style = "width:40%">
                                                <select v-model="student_form.schoolPreference3" :class="{ 'is-invalid select2 select2-hidden-accessible': student_form.errors.has('schoolPreference3') }"  class="form-control select2" name="schoolPreference3" id="schoolPreference3">
                                                    <option value=""> -- Select-- </option>
                                                    <option v-for="(item, index) in schoolList" :key="index" v-bind:value="item.id">{{item.name}} {{item.Level}}</option>
                                                </select>
                                                <has-error :form="student_form" field="schoolPreference3"></has-error>
                                                <span class="text-danger" id="schoolPreference3_err"></span>
                                            </td>
                                            <td v-if="this.std_class" id="class" style = "width:15%">
                                                <span>{{this.std_class}} <span v-if="this.stream">{{this.stream}}</span></span>
                                            </td>
                                            <td v-else>
                                            </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <hr>
            </div>
        </div>
    </div>
    <!-- stream preference -->
    <div class="card card-primary card-outline" id="main2">
        <div class="card-body">
            <div class="form-group">
            <label><b>Streams Preference</b></label>
            <small><i>(*Note: <i class="text-danger">*</i> (Symbol) meaning school selection from dropdown is compulsory) and "Optional" meaning school selection is Optional)</i></small>
                <div class="row form-group">
                    <div class="card-body col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group table-responsive">
                        <table id="dynamic-table" class="table table-sm table-bordered table-striped ">
                            <thead class="p-3 mb-2 bg-secondary text-white border border-info">
                                <tr >
                                    <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;'>Stream Preference</th>
                                    <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;'>Stream</th>
                                    <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;'>Class</th>
                                </tr>
                            </thead>
                            <tbody class="border border-info">
                                    <tr>
                                        <td style = "width:15%"><span class="badge badge-white">Preference 1 <i class="text-danger">*</i></span></td>
                                        <td style = 'width:70%'>
                                            <select v-model="student_form.stream1" :class="{ 'is-invalid select2 select2-hidden-accessible': student_form.errors.has('stream1') }" class="form-control select2" name="stream1" id="stream1">
                                                <option v-for="(item, index) in streamList" :key="index" v-bind:value="item.id">{{item.stream}}</option>
                                            </select>
                                            <has-error :form="student_form" field="stream1"></has-error>
                                            <span class="text-danger" id="stream1_err"></span>
                                        </td>
                                        <td v-if="this.std_class" id="class" style = "width:15%">
                                            <span>{{this.std_class}} <span v-if="this.stream">{{this.stream}}</span></span>
                                        </td>
                                        <td v-else>
                                        </td>
                                    </tr>
                                    <br>
                                    <tr>
                                        <td style = "width:15%"><span class="badge badge-white">Preference 2 (Optional)</span></td>
                                        <td style = 'width:70%'>
                                            <select v-model="student_form.stream2" :class="{ 'is-invalid select2 select2-hidden-accessible': student_form.errors.has('stream2') }" class="form-control select2" name="stream2" id="stream2">
                                                <option v-for="(item, index) in streamList" :key="index" v-bind:value="item.id">{{item.stream}}</option>
                                            </select>
                                            <has-error :form="student_form" field="stream2"></has-error>
                                            <span class="text-danger" id="stream2_err"></span>
                                        </td>
                                        <td v-if="this.std_class" id="class" style = "width:15%">
                                            <span>{{this.std_class}} <span v-if="this.stream">{{this.stream}}</span></span>
                                        </td>
                                            <td v-else>
                                        </td>
                                    </tr>
                                    <br>
                                    <tr>
                                        <td style = "width:15%"><span class="badge badge-white">Preference 3 (Optional)</span></td>
                                        <td style = 'width:70%'>
                                            <select v-model="student_form.stream3" :class="{ 'is-invalid select2 select2-hidden-accessible': student_form.errors.has('stream3') }" class="form-control select2" name="stream3" id="stream3">
                                                <option v-for="(item, index) in streamList" :key="index" v-bind:value="item.id">{{item.stream}}</option>
                                            </select>
                                            <has-error :form="student_form" field="stream3"></has-error>
                                            <span class="text-danger" id="stream3_err"></span>
                                        </td>
                                        <td v-if="this.std_class" id="class" style = "width:15%">
                                            <span>{{this.std_class}} <span v-if="this.stream">{{this.stream}}</span></span>
                                        </td>
                                        <td v-else>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <label >Contact Number:<i class="text-danger">*</i> </label>
                                <input type="number" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "8" minlength = "8" class="form-control" @change="remove_error('contact_number')" :class="{ 'is-invalid': student_form.errors.has('contact_number') }" id="contact_number" v-model="student_form.contact_number" placeholder="Contact No">
                                <has-error :form="student_form" field="contact_number"></has-error>
                                <span class="text-danger" id="emailError"></span>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <label>Email Address:</label>
                                <input type="text" class="form-control" @change="remove_error('email');validateEmail('email','emailError')" :class="{ 'is-invalid': student_form.errors.has('email') }" id="email" v-model="student_form.email" placeholder="Email Address">
                                <has-error :form="student_form" field="email"></has-error>
                                <span class="text-danger" id="emailError"></span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <label class="rp-3">Applying For Boarder:<i class="text-danger">*</i></label><br>
                                <label><input  type="radio" v-model="student_form.border" name="border" id="border" value="Yes" tabindex=""/> Yes</label>
                                <label><input  type="radio" v-model="student_form.border" name="border" id="border" value="No" tabindex=""/> No</label>
                                <has-error :form="student_form" field="border"></has-error>
                                <br><span class="text-danger" id="border_error"></span>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="this.attach">
                                <label>Uploaded Document:</label>
                                <a href="#" @click="openfile(attach)" class="fa fa-download"> Download</a>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                                <small><i>(*Note: Note: All the related documents need to be compiled into one document and upload)</i></small>
                                <label>Supporting Document:<i class="text-danger">*</i> (Max File Size 1.5 MB)</label><br>
                                <small><i>Document that needs to be attached (Parents transfer order/letter from employer)</i></small>
                                <input  type="file" name="attachments" class="form-control" v-on:change="onChangeFileUpload"  id="attachment">
                                <has-error :form="student_form" field="attachments"></has-error>
                            </div>
                        </div>
                        <div class="form-group row submitted" style="display:none">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="alert alert-success" role="alert">
                                    <h4 class="alert-heading">Application Received</h4>
                                    <p>Your application has been received and is currently under process by Admission Committee at Dzongkhag/Thromde level.</p>
                                </div>
                            </div>
                        </div>
                        <!-- selected dzongkhag/school-->
                        <div class="form-group row alert alert-success assignD" role="alert" style="display:none">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <label>Assigned School:</label>
                                    <label class="text-primary">{{schoolList[this.selectedschool]}}</label>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label>Assigned Stream:</label>
                                <label class="text-primary">{{ streamList[this.selectedStream] }}</label>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label>Status:</label>
                                <label class="text-primary">{{ this.appStatus }}</label>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                <label>Admitted As :</label>
                                <label class="text-primary">{{ this.admitted_as }}</label>
                            </div>
                        </div>
                        <br>
                        <div class="card-footer text-right">
                            <button type="button" class="btn btn-primary" id="addMore" @click="addMore()">Apply</button>
                        </div>
                    </div>
                </div>
                <hr>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    data(){
        return{
            is_student:false,
            std_id:'',
            std_class:'',
            std_present_class:'',
            std_present_school:'',
            level:'',
            org_id:'',
            from_class:'',
            stream:'',
            to_class:'',
            NoOfdays:'',
            from_date:'',
            to_date:'',
            attach:'',
            parent_school_dzongkhag:'',
            genderArray:{},
            dzongkhagArray:{},
            gewogArray:{},
            villageArray:{},
            OrgDetails:'',
            schoolList:[],
            dzongkhagList:[],
            classList:[],
            streamList:[],
            stdList:[],
            s_classList:[],
            parents_details:[],
            std_admission_details:'',
            response_data:[],
            draft_attachments:[],
            selectedStream:'',
            selectedschool:'',
            appStatus:'',
            admitted_as:'',
            //prefedined an array of the classes
            class_array:['AGE 2','AGE 3','AGE 4','AGE 5','PP', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII','XII'],
            student_form: new form({
                id:'',
                student:'',
                // admission_type:'',
                student_id:'',
                residence:'',
                dzongkhag:'',
                school:'',
                class:'',
                stream:'',
                dateOfapply:'',
                std_decission:'',
                relation:'',
                workingAddress:'',
                contact_number:'',
                email:'',
                schoolPreference1:'',
                schoolPreference2:'',
                schoolPreference3:'',
                stream1:'',
                stream2:'',
                stream3:'',
                textstream1:'',
                textstream2:'',
                textstream3:'',
                workingAddress:'',
                contactNumber:'',
                ImmediateConatct:'',
                border:'',
                actiontype:'portal',
                attachments:'',
                Application_type:'Out_side_cluster',
            })
        }
    },
    methods:{
        openfile(file){
            let file_path=file.replaceAll('/', 'SSS');
            let uri = 'admissions/viewFiles/'+file_path;
            window.open(uri,"_black");
        },
        showedit(item){
            if(item!="" || item!=[] || item!=null){
                // Show the modal
                $('#screening-modal').modal('show');
                this.clearFormValues();
                // Set form properties
                    this.student_form.relation = item.Relationship;
                    this.student_form.workingAddress = item.WorkAddress;
                    this.student_form.contactNumber = item.ContactNo;
                    this.student_form.residence = item.ResidenceAddress;
            }
        },
        clearFormValues() {
                // Clear form values
                this.student_form.relation = '';
                this.student_form.workingAddress = '';
                this.student_form.contactNumber = '';
                this.student_form.residence = '';
        },
        UpdateParents(){
                Swal.fire({
                    text: "Are you sure you want update this details ?",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes!',
                    }).then((result) => {
                    if(result.isConfirmed){
                        let formData = new FormData();
                        formData.append('student', this.student_form.student);
                        formData.append('student_id', this.student_form.student_id);
                        formData.append('workingAddress', this.student_form.workingAddress);
                        formData.append('contactNumber', this.student_form.contactNumber);
                        formData.append('residence', this.student_form.residence);
                        formData.append('relation', this.student_form.relation);
                        axios.post('/admissions/UpdateParents',formData)
                        .then((response) => {
                            let data = response.data;
                            if(data!=null){
                                Swal.fire({
                                text: "You have update details successfully",
                                icon: 'info',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Okay!',
                                });
                            }
                            else{
                                Swal.fire({
                                text: "Unexpected Error. Please try it again",
                                icon: 'error',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Okay!',
                                });
                            }  
                            this.$router.push('/applying_to_Out_side_cluster_school');
                            $('#screening-modal').modal('hide');
                            window.location.reload();     

                        })
                        .catch((error) => {
                            console.log("Error addMore:"+error);
                        })
                    }
                }); 
        },
        onChangeFileUpload(e){
            this.student_form.attachments = e.target.files[0];
        },
        getdzongkhagList(type){
            let uri ='masters/loadGlobalMasters/all_active_dzongkhag';
            axios.get(uri)
            .then(Response =>{
                let data = Response.data.data;
                this.dzongkhagList = data;
            }).catch(error => console.log(error));
        },

        getclassList(id){
            this.classList = [];
            axios.get('/masters/loadClassAge')
            .then(Response =>{
                let data = Response.data.data;
                this.s_classList = data;
            })
        },
        onChangeFileUpload(e){
            this.student_form.attachments = e.target.files[0];
        },
        async checkingInPrivateadmission(std_id){
            let type = 'outside_cluser';
            await axios.get('admissions/checkingInPrivateadmission/'+std_id+'/'+type)
                .then(response => {
                    let data = response.data;
                    if(data=='1'){
                        $('#addMore').hide();
                        let messages="You have already been accepted to a school. Please check your previous admission request, if done online.";
                        $('#main_form').hide();
                        $('#validation_message').html(messages);
                        $('#screenPermission').show();
                    }
                })
                .catch(function (error) {
                    console.log("Error......"+error)
                });
        },
    async getStuentparentDetails(id){
        await axios.get('admissions/getStuentparentDetails/'+id+'__PARENTS')
            .then(response => {
                let data = response.data;
                if(data!="" || data!=null || data!=undefined){
                    this.parents_details=data;
                }
                else{
                    this.parents_details = [];
                }
            })
            .catch(function (error) {
                console.log("Error......"+error)
            });
        },
        validated(){
            let ret=true;
            if($('#dzongkhag').val()==null){
                $('#dzongkhag_err').html('Please select Dzongkhag');
                $('#dzongkhag').focus();
                $('#dzongkhag').addClass('is-invalid');
                ret=false;
            }
            if($('#schoolPreference1').val()==null){
                $('#schoolPreference1_err').html('This field is required');
                $('#schoolPreference1').focus();
                $('#schoolPreference1').addClass('is-invalid');
                ret=false;
            }
            if($('#stream1').val()==null){
                $('#stream1_err').html('This field is required');
                $('#stream1').focus();
                $('#stream1').addClass('is-invalid');
                ret=false;
            }
            if($('#contact_number').val()==""){
                $('#contact_number_error').html('Please provide phone');
                ret=false;
            }
            if($('input[name="border"]:checked').val()==undefined){
                $('#border_error').html('Please choose');
                ret=false;
            }
            return ret;
        },
        async addMore(){
            if(this.validated()){
                Swal.fire({
                    text: "Are you sure you want apply transfer to mentioned preferences?",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes!',
                    }).then((result) => {
                    if(result.isConfirmed){
                        const config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                    }
                        let formData = new FormData();
                        formData.append('student', this.student_form.student);
                        // formData.append('admission_type', this.student_form.admission_type);
                        formData.append('student_id', this.student_form.student_id);
                        formData.append('class', this.student_form.class);
                        formData.append('border', this.student_form.border);
                        formData.append('dzongkhag', this.student_form.dzongkhag);
                        formData.append('schoolPreference1', this.student_form.schoolPreference1);
                        formData.append('schoolPreference2', this.student_form.schoolPreference2);
                        formData.append('schoolPreference3', this.student_form.schoolPreference3);
                        formData.append('stream1', this.student_form.stream1);
                        formData.append('stream2', this.student_form.stream2);
                        formData.append('stream3', this.student_form.stream3);
                        formData.append('org_id', this.student_form.user_org_id);
                        formData.append('dzo_id', this.student_form.user_dzo_id);
                        formData.append('textstream1', this.student_form.textstream1);
                        formData.append('textstream2', this.student_form.textstream2);
                        formData.append('textstream3', this.student_form.textstream3);
                        formData.append('std_class', this.std_class);
                        formData.append('dateOfapply', this.student_form.dateOfapply);
                        formData.append('std_decission', this.student_form.std_decission);
                        formData.append('Application_type', this.student_form.Application_type);
                        formData.append('attachments', this.student_form.attachments);
                        formData.append('contact_number', this.student_form.contact_number);
                        formData.append('email', this.student_form.email);
                        formData.append('existing_attachments', this.attach);
                        axios.post('/admissions/SaveClassXIAdmissionDetails',formData, config)
                        .then((response) => {
                            let data = response.data;
                            if(data!='null' && data!=''){
                                Toast.fire({
                                    icon: 'success',
                                    title: 'Your transfer application has been submitted successfully'
                                });
                                this.LoadAllReferences(data.student_id);
                                let message="Your application has been submitted successfully";
                                this.$router.push({name:'apply_for_school_ackowlegement',params: {data:message}});
                            }
                        })
                        .catch((error) => {
                            Toast.fire({
                                icon: 'error',
                                title: 'Unexpected Error.Please contact admistration'
                            });
                            console.log("Error:"+error);
                        })
                    }
                });
                $('#addMore').show();
            }
        },
        async LoadAllReferences(id){
            let type='Out_side_cluster';
            await axios.get('/admissions/LoadClassXIAdmissionDetails/'+id+'/'+type)
            .then(Response =>{
                let data = Response.data.data;
                if(data!='null' || data!=""){
                    this.appStatus = data.status;
                    if(this.appStatus == 'Admitted'){
                        $('#addMore').prop('disabled',true); 
                        $('.assignD').show();
                    }
                    else{
                        $('.submitted').show();
                    }
                    for(let i=0;i<=data.SchoolDzoPreference.length;i++){
                        if(i==0){
                            this.student_form.dzongkhag     =   data.SchoolDzoPreference[i].Dzongkhag_id;
                            this.getschoolList(this.student_form.dzongkhag);
                            $('#dzongkhag').val(data.SchoolDzoPreference[i].Dzongkhag_id).trigger('change');
                        }
                    }
                    //displaying school
                    for(let i=0;i<=data.SchoolDzoPreference.length;i++){
                        if(i==0){
                            this.student_form.schoolPreference1     =   data.SchoolDzoPreference[i].School_id;
                            $('#schoolPreference1').val(data.SchoolDzoPreference[i].School_id).trigger('change');
                            
                        }
                        if(i==1){
                            if(data.SchoolDzoPreference[1]!=undefined && data.SchoolDzoPreference[1]!=null){
                                this.student_form.schoolPreference2    =   data.SchoolDzoPreference[i].School_id;
                                $('#schoolPreference2').val(data.SchoolDzoPreference[i].School_id).trigger('change');
                            }
                        }
                        if(i==2){
                            if(data.SchoolDzoPreference[2]!=undefined && data.SchoolDzoPreference[2]!=null){
                                this.student_form.schoolPreference3     =   data.SchoolDzoPreference[i].School_id;
                                $('#schoolPreference3').val(data.SchoolDzoPreference[i].School_id).trigger('change');
                            }
                        }
                    }
                      //displaying streams
                    for(let i=0;i<=data.StreamPreference.length;i++){
                        if(i==0){
                            if(data.StreamPreference[0]!=undefined && data.StreamPreference[0]!=null){
                                this.student_form.stream1         =   data.StreamPreference[i].Stream_id;
                                this.student_form.textstream1     =   data.StreamPreference[i].Stream_name;
                                $('#stream1').val(data.StreamPreference[i].Stream_id).trigger('change');
                            }
                        }
                        if(i==1){
                            if(data.StreamPreference[1]!=undefined && data.StreamPreference[1]!=null){
                                this.student_form.stream2         =   data.StreamPreference[i].Stream_id;
                                this.student_form.textstream2     =   data.StreamPreference[i].Stream_name;
                                $('#stream2').val(data.StreamPreference[i].Stream_id).trigger('change');
                            }
                        }
                        if(i==2){
                            if(data.StreamPreference[2]!=undefined && data.StreamPreference[2]!=null){
                                this.student_form.stream3         =   data.StreamPreference[i].Stream_id;
                                this.student_form.textstream3     =   data.StreamPreference[i].Stream_name;
                                $('#stream3').val(data.StreamPreference[i].Stream_id).trigger('change');
                            }
                        }
                        //displaying streams
                        
                    }
                }
                this.attach= data.Attachement;
                this.student_form.border = data.border;
                this.student_form.contact_number = data.contact_number;
                this.student_form.email = data.email;
                this.admitted_as = data.admitted_as;
                this.selectedschool = data.selected_school.split("__")[0];
                this.selectedStream = data.selected_stream_id.split("__")[1];


            }).catch(error => console.log(error));
        },
        loadadmissions(id){
            this.student_form.student_seats=[];
            axios.get('/admissions/getorgclassDetails/'+id)
            .then(Response =>{
                let data = Response.data;
                if(data!='null' || data!=""){
                    this.response_data=data;
                }
                this.filepth= data.Attachment_Path;
            }).catch(error => console.log(error));
        },
        /**
         * method to remove fields
         */
        remove(type,id){
            Swal.fire({
                text: "Are you sure you wish to take this action ?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!',
            }).then((result) => {
                if(result.isConfirmed){
                    axios.get('/admissions/deleteclassDetails/'+id+'__'+type)
                    .then((response) => {
                        let data=response.data;
                        if(data.match('Accepted')){
                            // this.$router.push({name:'acknowledgement'});
                            let message="Your decision of accepting for selected school has been updated successfully<br /> Thank  you!";
                            this.$router.push({name:'acknowledgement',params: {data:message}});
                        }
                        else if(data.match('Rejected')){
                            let message="Your decision of rejecting for selected school has been updated successfully<br /> Thank  you!";
                            this.$router.push({name:'acknowledgement',params: {data:message}});
                            
                        }
                        else if(data.match('Deleted')){
                            let message="Your have removed school successfully<br /> Thank  you!";
                            this.$router.push({name:'acknowledgement',params: {data:message}});
                            
                        }
                    })
                    .catch((error) => {
                        console.log("Error remove:"+error);
                    })
                }
            });
        },
        async getstudentPersonalDetails(type){
            await axios.get('/admissions/getStudentDetailsFromPortal/'+type)
                .then(response => {
                let data = response.data;
                if(data != "" || $data!=""){
                    this.getStuentparentDetails(data.id);
                    this.DateOfBirth = data.DateOfBirth;
                    this.student_form.DateOfBirth = data.DateOfBirth
                    this.validateAge(this.DateOfBirth);
                    this.std_admission_details=data;
                    if(data.id!=null && data.id!=""){
                        this.getStudentClass(data.id);
                    }
                else{           
                    this.getStudentClass(data.StdAdmissionsId);
                }
                    this.org_id = this.std_admission_details.OrgOrganizationId;
                    this.getOrgDetails(data.OrgOrganizationId)
                    this.student_form.user_org_id = data.OrgOrganizationId;

                    //Function to load the school list as per feeders
                    if(type == 'Student'){
                        let uri2 ='organizations/loadOrganizationDetailsbyOrgId/'+this.org_id;
                        axios.get(uri2)
                        .then(Response =>{
                            if(Response!="" || Response!=null){
                                let dzongkhag_data = Response.data.data;
                                this.parent_school_dzongkhag = dzongkhag_data.dzongkhagId;
                                this.std_present_school = dzongkhag_data.name;
                                this.level=dzongkhag_data.level_name;
                                this.student_form.user_dzo_id = dzongkhag_data.dzongkhagId;
                            }
                        }).catch(error => console.log(error));

                        // let AdmissionType='ParentSchool';
                        // this.student_form.admission_type=AdmissionType;
                        // $("input[name=registrationType][value=" + AdmissionType + "]").prop('checked', true);
                    } else {
                        // this.student_form.admission_type=data.AdmissionType;
                        // $("input[name=registrationType][value=" + data.AdmissionType + "]").prop('checked', true);
                    }
                }
                else{
                    $('#main_form').hide();
                    $('#message').html('You are not yet registered in the system. Please register your self first to proceed further from here. <br> Thank you!');
                    $('#screenPermission').show();
                }
            });
        },
        getStudentClass(std_id){
            let uri = '/students/getStudentClassId/'+ std_id;
            try{
                axios.get(uri).then(response => {
                    let data= response.data;
                    if(data!="" && data!=null){
                     //have to check whether the student passed or failed
                        this.std_present_class = data.organization_data[0].class;
                        if(this.std_present_class!='X' && this.std_present_class!='10'){
                            $('#main_form').hide();
                            $('#main1').hide();
                            $('#main2').hide();
                            $('#validation_message').html('Only class XI students are eligible to apply students transfer from here. <br> Thank you!');
                            $('#screenPermission').show();
                        }
                        this.stream = data.stream;
                        let is_valid_age=this.validateAge();
                        //checking Age for class selection
                        if(is_valid_age > 5){
                            $('#age').show();
                            $('#class').hide();
                            $('#allClass').hide();
                        }
                            let index = this.class_array.indexOf(this.std_present_class);
                            index++;
                            this.std_class=this.class_array[index];//next class
                            this.classList.push(this.std_class);
                            this.student_form.class = this.std_class;
                        // this.loadAdmissionDates(this.std_present_class);
                    }
                });
            }catch(e){
                console.log('error loadactivedzongkhags '+e);
            }
        },
        checkForPreviousYearStudent(student_code){
            let uri = '/students/checkForPreviousYearStudent/'+ student_code;
                axios.get(uri).then(response => {
                    if(response.data!=null && response.data!=""){
                        $('#age').hide();
                        $('#class').show();
                        $('#allClass').hide();
                    }
                    else{
                        $('#age').hide();
                        $('#class').hide();
                        $('#allClass').show();
                    }
                });
        },
        validateAge(dob){
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            let date1 = new Date(dob);
            let date2 = '';
            if(this.org_type == 'ECCD'){
                date2 = new Date(this.eccdAdmissionDateValidation);
            } else {
                date2 = new Date(this.schoolAdmissionDateValidation);
            }

            const dob_date = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
            const admission_date = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

            let age = Math.floor((admission_date-dob_date) / _MS_PER_DAY);
            let is_valid_age=0;
                if(age <=1096){ //age 3
                    is_valid_age = 3;
                }
                else{ //age 4
                    is_valid_age = 5; 
                }
            return is_valid_age;

        },
        checkSchoolList(orgId){
            for(let i=0;i<this.response_data.length;i++){
                if(this.response_data[i].organization.id == orgId){
                    return false;
                }
            }
            return true;
        },

        getstreamListByid(id){
            let classId=$('#class').val();
            if(id!=""){
                classId=id;
            }
            axios.get('/masters/getStreamByclassId/' +classId)
            .then(Response =>{
                let data = Response.data;
                this.classList = data;
            })
        },

        getOrgDetails(id){
            axios.get('/organizations/loadOrganizationDetailsbyOrgId/' +id)
            .then(response =>{
                let data = response.data.data;
                if(data!="" ||data!=null){
					this.student_form.dzongkhagName=data.dzongkhag;
					this.student_form.gewog=data.gewog;
					this.student_form.chewog=data.chewog;
				}	
            })
        },
        applyselect(){
            if(!$('#dzongkhag').attr('class').includes('select2')){
            $('#dzongkhag').addClass('select2');
            }
            if(!$('#school').attr('class').includes('select2')){
            $('#school').addClass('select2');
            }
            if(!$('#class').attr('class').includes('select2')){
            $('#class').addClass('select2');
            }
            if(!$('#stream').attr('class').includes('select2')){
            $('#stream').addClass('select2');
            }
        },
        loadGenderList(uri="masters/loadGlobalMasters/all_active_gender"){
            axios.get(uri)
            .then(response => {
                let data = response;
                this.sex_idList =  data.data.data;
                for(let i=0;i<data.data.data.length;i++){
                    this.genderArray[data.data.data[i].id] = data.data.data[i].name;
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        removeerror(fieldid){
            if($('#'+fieldid).val()!=""){
                $('#'+fieldid).removeClass('is-invalid');
            }
        },

        async changefunction(id){
            if($('#'+id).val()!=""){
                $('#'+id).removeClass('is-invalid');
                $('#'+id+'_err').html('');
                $('#'+id).addClass('select2');
            }
            if(id=="std_class"){
                this.student_form.class=$("#std_class option:selected" ).text();
            }
            if(id == 'dzongkhag'){
                this.student_form.dzongkhag=$('#dzongkhag').val();
                this.getschoolList(this.student_form.dzongkhag);
            }
            if(id=="schoolPreference1"){
                this.student_form.schoolPreference1=$('#schoolPreference1').val();
                this.checkforselectedval(1);
                // this.checkforsameschool(this.student_form.schoolPreference1,1)
                // this.getStreamList(this.student_form.schoolPreference1);
                
            }
            if(id=="schoolPreference2"){
                this.student_form.schoolPreference2=$('#schoolPreference2').val();
                this.checkforselectedval(2);
                // this.checkforsameschool(this.student_form.schoolPreference2,2)
                // this.getStreamList(this.student_form.schoolPreference2);
            }
            if(id=="schoolPreference3"){
                this.student_form.schoolPreference3=$('#schoolPreference3').val();
                this.checkforselectedval(3);
                // this.checkforsameschool(this.student_form.schoolPreference3,3)
                // this.getStreamList(this.student_form.schoolPreference3);
            }
            if(id == 'stream1'){
                this.student_form.stream1=$('#stream1').val();
                this.checkforselectedval(1);
                this.student_form.textstream1=$("#stream1 option:selected" ).text();
            }
            if(id == 'stream2'){
                this.student_form.stream2=$('#stream2').val();
                this.checkforselectedval(2);
                this.student_form.textstream2=$("#stream2 option:selected" ).text();
            }
            if(id == 'stream3'){
                this.student_form.stream3=$('#stream3').val();
                this.checkforselectedval(3);
                this.student_form.textstream3=$("#stream3 option:selected" ).text();
            }
        },
        checkforselectedval(cout){
            let disabled_type=false;
            $('#addMore').prop('disabled',false);
            //checking for same school
            if($('#schoolPreference1').val()!="" && $('#schoolPreference1').val()!=null && $('#schoolPreference2').val()!="" && $('#schoolPreference2').val()!=null && $('#schoolPreference1').val()==$('#schoolPreference2').val()){
                $('#schoolPreference'+cout+'_err').html('This school is already selected');
                $('#schoolPreference'+cout).val('');
                 disabled_type=true;
                // $('#schoolPreference'+cout).val('').trigger('change');
                // $('#schoolPreference'+cout).val('')="";
            }
            if($('#schoolPreference2').val()!="" && $('#schoolPreference2').val()!=null && $('#schoolPreference3').val()!="" && $('#schoolPreference3').val()!=null && $('#schoolPreference2').val()==$('#schoolPreference3').val()){
                $('#schoolPreference'+cout+'_err').html('This school is already selected');
                $('#schoolPreference'+cout).val('');
                 disabled_type=true;
                // $('#schoolPreference'+cout).val('').trigger('change');
                // $('#schoolPreference'+cout).val('')="";
            }
            if($('#schoolPreference1').val()!="" && $('#schoolPreference1').val()!=null && $('#schoolPreference3').val()!="" && $('#schoolPreference3').val()!=null && $('#schoolPreference1').val()==$('#schoolPreference3').val()){
                $('#schoolPreference'+cout+'_err').html('This school is already selected');
                $('#schoolPreference'+cout).val('');
                 disabled_type=true;
                // $('#schoolPreference'+cout).val('').trigger('change');
                // $('#schoolPreference'+cout).val('')="";
            }

             // checking for same stream
            if($('#stream1').val()!="" && $('#stream1').val()!=null && $('#stream2').val()!="" && $('#stream2').val()!=null && $('#stream1').val()==$('#stream2').val()){
                $('#stream'+cout+'_err').html('This stream is already selected');
                $('#stream'+cout).val('');
                 disabled_type=true;
                // $('#stream'+cout).val('').trigger('change');

            }
            if($('#stream2').val()!="" && $('#stream2').val()!=null && $('#stream3').val()!="" && $('#stream3').val()!=null && $('#stream2').val()==$('#stream3').val()){
                $('#stream'+cout+'_err').html('This stream is already selected');
                $('#stream'+cout).val('');
                 disabled_type=true;
                // $('#stream'+cout).val('').trigger('change');
            }
            if($('#stream1').val()!="" && $('#stream1').val()!=null && $('#stream3').val()!="" && $('#stream3').val()!=null && $('#stream1').val()==$('#stream3').val()){
                $('#stream'+cout+'_err').html('This stream is already selected');
                $('#stream'+cout).val('');
                 disabled_type=true;
                // $('#stream'+cout).val('').trigger('change');
            }
            if(disabled_type){
                $('#addMore').prop('disabled',true);
                $('#addMore').hide();
            }else{
                $('#addMore').prop('disabled',false);
                $('#addMore').show();
            }
        },
        
        getstudentBasicDetailsForPortal(id){
            axios.get('/admissions/getstudentBasicDetailsForPortal/'+id)
                .then(response => {
                let data = response.data;
                if(data != "" || data!=null){
                    $('#student_id').prop('disabled',true);
                    this.std_admission_details=data;
                    this.std_class=data.class_id;
                    this.org_id = this.std_admission_details.OrgOrganizationId;

                    if(this.std_class.match("AGE")){
                        this.student_form.admission_type='ECCD';
                        $('#new').prop('disabled',true);
                        $('#existing').prop('disabled',true);
                    }
                    else{
                        this.student_form.admission_type='PP';
                        $('#new').prop('disabled',true);
                        $('#existing').prop('disabled',true);
                    }
                    
                }
                else{
                    $('#main_form').hide();
                    $('#message').html('You are not yet registered in the system. Please register your self first to proceed further from here. <br> Thank you!');
                    $('#screenPermission').show();
                }
            });

        },
        async CheckingOtherApplication(std_id){
            let $type = 'outside_cluster';
            let uri='admissions/CheckingOtherApplication/'+std_id+'/'+$type;
                await axios.get(uri)
                .then(response =>{
                    let data = response.data;
                    if(data!=null && data!=''){
                        $('#addMore').hide();
                        $('#main1').hide();
                        $('#main2').hide();
                        let messages="You have already applied class XI admission to other admissions type. <br> Thank You!";
                        $('#main_form').hide();
                        $('#validation_message').html(messages);
                        $('#screenPermission').show();
                    }
                })
                .catch(function (error) {
                    console.log('error: '+error);
                });
        },
        async crosscheckCriteria(std_code){
            let uri='admissions/checkingAndPullingBsceaMarks/'+std_code;
                await axios.get(uri)
                .then(response =>{
                    this.streamE ='';
                    let data = response.data;
                    if(data.Science==true){
                        this.streamE = this.streamE+"Science;";
                    }
                    if(data.Commerce ){
                        this.streamE = this.streamE+"Commerce;";
                    }
                    if(data.Arts==true ){
                        this.streamE = this.streamE+"Arts;";
                    }
                    // if(data.Rigzhung==true){
                    //     this.streamE = this.streamE+"Rigzhung;";
                    // }
                    // else{
                    //     this.streamE = "ArtsAndRig"; 
                    // }
                    this.getStreamList(this.streamE);
                })
                .catch(function (error) {
                    console.log('error: '+error);
                });
        },
        async checkPassFail(std_code){
            let uri='admissions/checkPassFailForBscea/'+std_code;
                await axios.get(uri)
                .then(response =>{
                    let data = response.data.data;
                    if(data.result != "PCA"){
                        $('#addMore').hide();
                        let messages="You are not eligible for class XI. You should have scored PCA to proceed from here. <br> Thank You!";
                        $('#main_form').hide();
                        $('#validation_message').html(messages);
                        $('#screenPermission').show();
                    }
                })
                .catch(function (error) {
                    console.log('error: '+error);
                });
        },
        getStreamList(stream){
            let uri = '/organizations/getStreamListForPrivate/'+ stream;
            try{
                this.streamList =[];
                axios.get(uri).then(response => {
                    let data= response.data;
                    this.streamList=data;
                    if(data!=null && data!=''){
                        for(let i=0;i<data.length;i++){
                            this.streamList[data[i].id] = data[i].stream;
                        }
                    }
                });
            }catch(e){
                console.log('error '+e);
            }
        },
        //pulling only private school
        getschoolList(dzo_id){
            if(this.appStatus == 'Admitted'){
                this.dzo_id = 'ALL';
            }
            else{
                this.dzo_id = dzo_id;
            }
            this.schoolList=[];
            this.schoolType = 'public';
            let uri = '/organizations/loadSchoolAllPrivateSchool/'+this.schoolType+'/'+dzo_id;
            try{
                axios.get(uri).then(response => {
                    let data= response.data;
                    this.schoolList=data;
                    for(let i=0;i<data.length;i++){
                        this.schoolList[data[i].id] = data[i].name;
                    }
                });
            }catch(e){
                console.log('error loadactivedzongkhags '+e);
            }

        },
        showErrorMsg(text){
            Swal.fire({
                html: text,
                icon: 'error'
            });
        },

        checkForAdmissionWindow(){
            axios.get('masters/loadGlobalMasters/Admission_XI_Outside_School')
            .then(response => {
                let data = response.data.data;
                if(data!=null){
                    this.from_date = data.from_date;
                    this.to_date = data.to_date;

                    var today = new Date();
                    let month=today.getMonth()+1;
                    if(month.toString().length==1){
                            month='0'+month;
                    }
                    let date=today.getDate();
                    if(date.toString().length==1){
                            date='0'+date;
                    }
                    var present_date = today.getFullYear()+'-'+month+'-'+date;
                    if(this.to_date >= present_date && this.from_date <= present_date){
                        $('#selectschool').show();
                        $('#finalbtn').show();
                        $('#validationmessages').hide();
                    }else{
                        $('#addMore').hide();
                        let messages="Class XI Admission Dates for Applying Outside Cluster School is closed. <br> Thank You!";
                        // $('#main_form').hide();
                        // $('#main1').hide();
                        $('#validation_message').html(messages);
                        $('#screenPermission').show();
                    }
                } else{
                    $('#addMore').hide();
                    let messages="Class XI Admission Date not yet configured. <br> Thank You!";
                    // $('#main1').hide();
                    $('#validation_message').html(messages);
                    $('#screenPermission').show();
                }
            })
            .catch(errors => {
                console.log(errors)
            });
        }
    },
    async mounted() {
        this.checkForAdmissionWindow();
        this.getdzongkhagList();
        $('.select2').select2();
        $('.select2').select2({
            theme: 'bootstrap4'
        });
        $('.select2').on('select2:select', function (el){
            Fire.$emit('changefunction',$(this).attr('id'));
        });

        Fire.$on('changefunction',(id)=> {
            this.changefunction(id);
        });
        this.getclassList();
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.userId=data.id;;
            this.std_id=data['std_id'];
            this.CheckingOtherApplication(this.std_id);
            this.LoadAllReferences(this.std_id);
            this.checkingInPrivateadmission(this.std_id);
            this.student_code = data['student_code'];
            this.dob = data['dob'];
            this.checkForPreviousYearStudent(this.student_code);
            this.checkPassFail(this.student_code);
            this.crosscheckCriteria(this.student_code)
            this.getStuentparentDetails(this.std_id);
            this.id = data['id'];
            this.loadadmissions(this.std_id);

            let user_type=data['user_type'];
            if(data['user_type']=="Student"){
                this.student_form.student_id=this.std_id;
                this.is_student=true;
                this.getOrgDetails(data.organization_id);
                $('#selectStudent').hide();
                this.getstudentPersonalDetails(user_type);
            }
            else{
                $('#present_school').hide();
                $('#pheader').hide();
                
            }
        })
        .catch(errors => {
            console.log(errors)
        });

        this.loadGenderList();
    },
}
</script>
